import './TripAdvisorRating.scss'

import classNames from 'classnames'
import { config } from 'lib/config'
import { i18n } from 'lib/i18n'
import React from 'react'

interface RatingsProps {
  value: number
  reviewCount: number
}

export function TripAdvisorRating({ value = 0, reviewCount }: RatingsProps): JSX.Element {
  const reviewsLabel = i18n('pdc-card.reviews')
  const generateRatingIcons = (): Array<JSX.Element> =>
    [1, 2, 3, 4, 5].map((rating, index) => {
      let fill = ''
      if (value - rating >= 0) {
        fill = 'background-fill-full'
      } else if (rating - value <= 0.5) {
        fill = 'background-fill-half'
      }

      return (
        <div
          key={`rating-icon-${index}`}
          className={classNames('TripAdvisorRating__circle-icon', fill)}
        />
      )
    })

  return (
    <div className="TripAdvisorRating">
      <img src={`${config.ROOT_PATH}images/logos/trip-advisor.svg`} alt="TripAdvisor" />
      <div className="TripAdvisorRating__icon-wrapper">{generateRatingIcons()}</div>
      <span className="TripAdvisorRating__review-count-label">
        {reviewCount} {reviewsLabel}
      </span>
    </div>
  )
}
